import { SEARCH_KEY } from '../DataGrid/DataGridFilters';
import * as actions from './actions';
export const assembleRows = data => {
  let fakeRows = new Array(data.totalRecords).fill({});
  let loadedRows = data.fetchedRows;
  let pageNum = Number(data.pageNumber) - 1;
  let frontSlice = [0, Number(data.pageSize) * pageNum];
  let backSlice = [Number(data.pageSize) * Number(data.pageNumber)];
  let allRows = [...fakeRows.slice(...frontSlice), ...data.fetchedRows, ...fakeRows.slice(...backSlice)];
  return {
    allRows,
    loadedRows
  };
};
export const createCacheKey = (sort, pagination, filter) => {
  const params = {
    sortKey: sort.key,
    sortOrder: sort.order,
    pageSize: pagination.pageSize,
    pageNumber: pagination.pageNumber,
    searchQuery: filter && filter[SEARCH_KEY] !== undefined ? filter[SEARCH_KEY].value : ''
  };
  return new URLSearchParams(params).toString();
};
export function generateAsyncStateParams(action, sort, pagination, filter) {
  /* eslint-disable */
  const {
    dispatch,
    handleApiRequest,
    transformFn,
    defaultSort,
    key: sortOrFilterKey,
    value: filterValue,
    ...payload
  } = action.payload;
  /* eslint-enable */

  const asyncState = {
    sort: sort,
    pagination: pagination,
    filter: filter
  };
  let pageNumber = 1;
  let pageSize = pagination.pageSize;
  switch (action.type) {
    case actions.setSort.type:
      {
        asyncState.sort = {
          ...sort,
          key: sortOrFilterKey,
          ...payload
        };
        asyncState.pagination = {
          ...pagination,
          currentPage: 0
        };
        break;
      }
    case actions.goToPage.type:
      {
        const {
          payload: pageIndex
        } = payload;
        pageNumber = pageIndex + 1;
        asyncState.pagination = {
          ...pagination,
          currentPage: pageIndex
        };
        break;
      }
    case actions.setPageSize.type:
      {
        const {
          payload: updatedPageSize
        } = payload;
        pageSize = updatedPageSize;
        asyncState.pagination = {
          ...pagination,
          currentPage: 0,
          pageSize
        };
        break;
      }
    case actions.updateFilter.type:
      {
        asyncState.pagination = {
          ...pagination,
          currentPage: 0
        };
        asyncState.filter = {
          ...filter,
          [sortOrFilterKey]: {
            ...filter[sortOrFilterKey],
            key: sortOrFilterKey,
            value: filterValue
          }
        };
        break;
      }
    default:
      {
        break;
      }
  }
  return {
    pageNumber,
    pageSize,
    asyncState
  };
}
export function generateFakeRows(dispatch, transformFn, totalRecords, pageSize) {
  const fakeRows = transformFn(new Array(totalRecords).fill({}));
  dispatch({
    type: actions.setDataGridState.type,
    payload: {
      allRows: fakeRows,
      filteredRows: fakeRows,
      visibleRows: fakeRows.slice(0, pageSize),
      pageCount: Math.round(fakeRows / pageSize)
    }
  });
}